// Centralized regex definitions read from env with safe fallbacks

function parseRegex(raw?: string, fallback?: string): RegExp {
  const val = raw?.trim();
  if (!val) return new RegExp(fallback || '');

  // Allow either /pattern/flags format or raw pattern
  if (val.startsWith('/') && val.lastIndexOf('/') > 0) {
    const lastSlash = val.lastIndexOf('/');
    const pattern = val.substring(1, lastSlash);
    const flags = val.substring(lastSlash + 1);
    try {
      return new RegExp(pattern, flags);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') console.warn('Invalid regex from env (slash form), using fallback:', raw, e);
      return new RegExp(fallback || '');
    }
  }

  try {
    return new RegExp(val);
  } catch (e) {
    if (process.env.NODE_ENV === 'development') console.warn('Invalid regex from env, using fallback:', raw, e);
    return new RegExp(fallback || '');
  }
}

/**
 * Read an env variable by name and parse it, with a fallback. Logs helpful messages in development.
 */
function getEnvRegex(varName: string, fallback?: string): RegExp {
  const raw = (process.env as Record<string, string | undefined>)[varName];
  if (process.env.NODE_ENV === 'development') {
    if (!raw) {
      console.info(`[regex] env ${varName} not set — using fallback`);
    } else {
      console.info(`[regex] env ${varName} loaded: ${raw.length > 200 ? raw.slice(0, 200) + '...' : raw}`);
    }
  }
  return parseRegex(raw, fallback);
}

export const EMAIL_REGEX = getEnvRegex('REACT_APP_EMAIL_REGEX', '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[A-Za-z]{2,}$');
export const MOBILE_REGEX = getEnvRegex('REACT_APP_MOBILE_REGEX', '^[6-9][0-9]{9}$');
export const AADHAR_REGEX = getEnvRegex('REACT_APP_AADHAR_REGEX', '^[0-9]{12}$');
export const UDHYOG_AADHAR_REGEX = getEnvRegex('REACT_APP_UDHYOG_AADHAR_REGEX', '^UAM[0-9]{9}$');
export const GST_REGEX = getEnvRegex('REACT_APP_GST_REGEX', '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$');
export const PAN_REGEX = getEnvRegex('REACT_APP_PAN_REGEX', '^[A-Z]{5}[0-9]{4}[A-Z]$');
export const IFSC_REGEX = getEnvRegex('REACT_APP_IFSC_REGEX', '^[A-Z]{4}0[A-Z0-9]{6}$');

const DEFAULT_REGEXES = {
  EMAIL_REGEX,
  MOBILE_REGEX,
  AADHAR_REGEX,
  UDHYOG_AADHAR_REGEX,
  GST_REGEX,
  PAN_REGEX,
  IFSC_REGEX,
};

export default DEFAULT_REGEXES;
